module.exports = __webpack_public_path__ + "files/1bf71be111189e76987a4bb9b3115cb7.ttf";


//////////////////
// WEBPACK FOOTER
// ./fonts/open-sans-v13-latin-ext_latin_cyrillic-ext_greek-ext_greek_cyrillic_vietnamese-300.ttf
// module id = 1573
// module chunks = 60